var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 37,
    viewBox: "0 0 82 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16318",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11084 1.37939C1.11084 0.82711 1.50802 0.379395 1.99797 0.379395H81.1108V35.8777H1.11084V1.37939Z",
    fill: "white",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16319",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.04798C1 0.469196 1.39654 0 1.8857 0H81V13H1V1.04798Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3290",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58137 4.57338C5.97553 4.57338 6.29506 4.25385 6.29506 3.85969C6.29506 3.46553 5.97553 3.146 5.58137 3.146C5.18721 3.146 4.86768 3.46553 4.86768 3.85969C4.86768 4.25385 5.18721 4.57338 5.58137 4.57338Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3291",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58137 7.36415C5.97553 7.36415 6.29506 7.04462 6.29506 6.65046C6.29506 6.2563 5.97553 5.93677 5.58137 5.93677C5.18721 5.93677 4.86768 6.2563 4.86768 6.65046C4.86768 7.04462 5.18721 7.36415 5.58137 7.36415Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3292",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58137 10.1547C5.97553 10.1547 6.29506 9.83514 6.29506 9.44098C6.29506 9.04682 5.97553 8.72729 5.58137 8.72729C5.18721 8.72729 4.86768 9.04682 4.86768 9.44098C4.86768 9.83514 5.18721 10.1547 5.58137 10.1547Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3293",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51642 4.57338C8.91058 4.57338 9.23011 4.25385 9.23011 3.85969C9.23011 3.46553 8.91058 3.146 8.51642 3.146C8.12226 3.146 7.80273 3.46553 7.80273 3.85969C7.80273 4.25385 8.12226 4.57338 8.51642 4.57338Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3294",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51642 7.36415C8.91058 7.36415 9.23011 7.04462 9.23011 6.65046C9.23011 6.2563 8.91058 5.93677 8.51642 5.93677C8.12226 5.93677 7.80273 6.2563 7.80273 6.65046C7.80273 7.04462 8.12226 7.36415 8.51642 7.36415Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3295",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51642 10.1547C8.91058 10.1547 9.23011 9.83514 9.23011 9.44098C9.23011 9.04682 8.91058 8.72729 8.51642 8.72729C8.12226 8.72729 7.80273 9.04682 7.80273 9.44098C7.80273 9.83514 8.12226 10.1547 8.51642 10.1547Z",
    fill: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23990",
    x: 13.0918,
    y: 2.29224,
    width: 30,
    height: 8,
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23991",
    x: 13.0918,
    y: 2.29224,
    width: 30,
    height: 8,
    fill: "#8D8D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1A);
export default __webpack_public_path__ + "static/media/Section1A.d5880913667bb03780dc9a07af3f2887.svg";
export { ForwardRef as ReactComponent };